// extracted by mini-css-extract-plugin
export default {"container":"choice_firm_container__94ozb","list":"choice_firm_list__aRXc0","item":"choice_firm_item__O-lY0"};